import { queueFont } from "../queueFont";
import { WelcomeHeader } from "./WelcomeHeader";
import { CareCornerLogo } from "./CareCornerLogo";

type LegacyGlobalQueueBoardProps = {
  clinicName: string;
  clinicLogoUrl: string;
  hasClinicLogo: boolean;
  queueText: string;
};

export function LegacyGlobalQueueBoard({
  clinicName,
  clinicLogoUrl,
  hasClinicLogo,
  queueText,
}: LegacyGlobalQueueBoardProps) {
  return (
    <div
      className={`${queueFont} relative box-border flex min-h-screen w-full max-w-[100vw] select-none flex-col items-center justify-center overflow-hidden bg-white px-[clamp(20px,3.5vmin,64px)] pb-[clamp(96px,11vmin,160px)] pt-[clamp(20px,3.5vmin,64px)] antialiased`}
    >
      <CareCornerLogo variant="wall" />

      <WelcomeHeader clinicName={clinicName} />

      <div
        className={`${queueFont} mb-[clamp(8px,1.5vmin,20px)] mt-[clamp(96px,12vmin,180px)] text-[clamp(14px,2vmin,26px)] font-bold tracking-[0.12em] text-[#334155]`}
      >
        NEXT QUEUE
      </div>

      <div className="flex flex-wrap items-center justify-center gap-[clamp(16px,3vmin,40px)]">
        <div
          className={`${queueFont} text-[clamp(152px,26vmin,420px)] font-extrabold leading-none text-[#0b3a66] [font-variant-numeric:tabular-nums] [text-rendering:optimizeLegibility]`}
        >
          {queueText}
        </div>

        {hasClinicLogo ? (
          <>
            <div className="min-h-[clamp(80px,14vmin,160px)] w-[clamp(2px,0.35vmin,4px)] self-stretch rounded-full bg-[#cbd5e1]" />
            <img
              src={clinicLogoUrl}
              alt=""
              className="h-[clamp(72px,14vmin,140px)] w-[clamp(72px,14vmin,140px)] object-contain"
            />
          </>
        ) : null}
      </div>
    </div>
  );
}
